import { LocalizationPage } from './LocalizationPage';

export default LocalizationPage;
